/**
 * Central configuration — tenant-safe (2026-08-17, agentos-tenant-bootstrap).
 *
 * Empty/unset VITE_* NEVER falls back to an operator (arkturian.com)
 * endpoint or an operator access list. Empty means same-origin (APIs) or
 * "not configured" (storage). Operator values come from the operator's own
 * build env. Origin: the David tenant instance — previously AUTH_API,
 * STORAGE_API and the ALLOWED_EMAILS list were hardcoded, so a tenant
 * build authenticated against the operator's auth-api and then rejected
 * every tenant user for not being on the operator's list.
 */

function env(name: string): string {
  const v = (import.meta.env as Record<string, string | undefined>)[name];
  return (v ?? '').trim().replace(/\/$/, '');
}
function sameOrigin(): string {
  return typeof window !== 'undefined' ? window.location.origin : '';
}

/** issue-api base. Empty → same-origin `/api` (tenant nginx routes it). */
export const ISSUE_API_BASE = env('VITE_ISSUE_API_BASE') || `${sameOrigin()}/api`;

/** auth-api base. Empty → same-origin (`/api/v1/auth` → auth-api). */
export const AUTH_API = env('VITE_AUTH_API') || sameOrigin();

/** storage-api base for attachments. Empty → uploads disabled. */
export const STORAGE_API = env('VITE_STORAGE_API');
export const STORAGE_ENABLED = STORAGE_API !== '';

/** Optional e-mail allowlist (comma-separated). Empty → every user the
 *  instance's auth-api accepts may use the board. NEVER an operator list. */
export const ALLOWED_EMAILS: string[] = env('VITE_ALLOWED_EMAILS')
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);
export function emailAllowed(email: string | undefined | null): boolean {
  if (ALLOWED_EMAILS.length === 0) return true;
  return !!email && ALLOWED_EMAILS.includes(email.toLowerCase());
}

/** Optional external links in the sidebar; empty → hidden. */
export const DOCS_URL = env('VITE_DOCS_URL');
export const MCP_URL = env('VITE_MCP_URL');

/** Instance label shown on the login screen. */
export const INSTANCE_LABEL = env('VITE_INSTANCE_LABEL') || 'Issues';

export const AUTH_DISABLED = env('VITE_DISABLE_AUTH') === 'true';
